<div class="modal-dialog modal-dialog-centered" role="document">
    
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ 'tagadmin.tagadministration' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
          
          <h6 class="font-weight-light">{{ 'tagadmin.customertags' | trans }}</h6>
          <div class="input-group mb-2">
            <input type="text" class="form-control" placeholder="{{ 'tagadmin.customertagsplace' | trans }}" aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="newtagtitle">
            <div class="input-group-append h-35">
              <button (click)="addTag('customer')" class="btn btn-list bw" type="button"><span class="material-icons" >add</span></button>
            </div>
          </div>
          <ng-container  *ngFor="let ctag of customerTags">
            
            <div class="input-group mb-2">
              <input type="text" class="form-control" [value]="ctag.title" (keyup)="editTag(ctag)">
              <div class="input-group-append h-35">
                <button class="btn btn-list bw" (click)="deleteTag(ctag)" type="button"><span class="material-icons">delete</span></button>
              </div>
            </div>
  
        
          </ng-container>

          <h6 class="font-weight-light">{{ 'tagadmin.projecttags' | trans }}</h6>
          <div class="input-group mb-2">
            <input type="text" class="form-control" placeholder="{{ 'tagadmin.customertagsplace' | trans }}" aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="newtagtitle">
            <div class="input-group-append h-35">
              <button (click)="addTag('project')" class="btn btn-list bw" type="button"><span class="material-icons" >add</span></button>
            </div>
          </div>
          <ng-container  *ngFor="let ptag of projectTags">
            
            <div class="input-group mb-2">
              <input type="text" class="form-control" [value]="ptag.title" (keyup)="editTag(ptag)">
              <div class="input-group-append h-35">
                <button class="btn btn-list bw" (click)="deleteTag(ptag)" type="button"><span class="material-icons">delete</span></button>
              </div>
            </div>
  
        
          </ng-container>

    

            <!-- <div *ngFor="let ctag of customerTags">
                <input type="text" [value]="ctag.title" (keyup)="editTag(ctag)">
                <span class="material-icons" (click)="deleteTag(ctag)">delete</span>
              </div>
              <div>
                <input type="text" [(ngModel)]="newtagtitle">
                <span class="material-icons" (click)="addTag()">add</span>
              </div> -->
      </div>
      </div>
    </div>
